import { Flex, Tag } from 'antd';
import { useCallback, useMemo } from 'react';

import type { BottomContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { PF } from '@pages/Clients/NewClientsList/data/constants';

export const ServicesSumSelected: BottomContentType = ({ id }) => {
  const { filtersMap, onChangeServicesSumRange } = useNewClientsListContext();

  const { servicesSumRange } = filtersMap.get(id)!;

  const values = useMemo(() => {
    const { from, to } = servicesSumRange;

    return [
      {
        value: from,
        label: `от ${from?.toLocaleString('ru-RU', {
          maximumFractionDigits: 2,
        })}`,
      },
      {
        value: to,
        label: `до ${to?.toLocaleString('ru-RU', {
          maximumFractionDigits: 2,
        })}`,
      },
    ].filter(({ value }) => value !== null);
  }, [servicesSumRange]);

  const onDelete = useCallback(
    (value: number | null) => {
      if (value === servicesSumRange.from) {
        onChangeServicesSumRange({ from: null, to: servicesSumRange.to }, id);
      } else if (value === servicesSumRange.to) {
        onChangeServicesSumRange({ from: servicesSumRange.from, to: null }, id);
      }
    },
    [servicesSumRange, onChangeServicesSumRange, id]
  );

  if (values.length === 0) {
    return null;
  }

  return (
    <Flex className={`${PF}__tags`} wrap="wrap" gap="4px">
      {values.map(({ value, label }) => (
        <Tag
          key={value}
          className={`${PF}__tag`}
          closable
          onClose={() => onDelete(value)}
        >
          {label}
        </Tag>
      ))}
    </Flex>
  );
};
